import { useCallback } from 'react';
import { handleFilterResetUserContext, handleFilterUpdateInUserContext } from 'common/pagination';

export function useCaseReportFilter(filter, userContext, reportType) {
  const handleFilterUpdate = (e) => {
    const retainVal = e?.target?.name === 'retain_filters' ? e?.target?.value : false;
    if (e?.target?.name === 'retain_filters') {
      handleFilterUpdateInUserContext(userContext, 'filters', 'report', reportType, 'retain_filters', retainVal, false);
      handleFilterResetUserContext(userContext, 'filters', 'report', reportType, retainVal ? filter : {}, false);
    } else if (userContext?.firmDetails?.user_preferences?.filters?.report?.[reportType]?.retain_filters) {
      handleFilterResetUserContext(userContext, 'filters', 'report', reportType, filter, true);
    }
  };

  const handleManualFilterUpdate = useCallback(() => {
    if (userContext?.firmDetails?.user_preferences?.filters?.report?.[reportType]?.retain_filters) {
      handleFilterResetUserContext(userContext, 'filters', 'report', reportType, filter, true);
    }
  }, [filter, userContext, reportType]);

  return {
    handleFilterUpdate,
    handleManualFilterUpdate,
  };
}
